// Modules
import React, { ReactNode } from 'react'
import { ThemeProvider } from '@dasa-health/alma-react'

// Components
import { navTheme } from 'theme'
import { useCurrentLaboratory } from 'redesign/hooks/useCurrentLaboratory'
import { SnackbarProvider } from 'redesign/context/snackbar'
import { CustomSnackbar } from 'redesign/components/molecules/CustomSnackbar'
import { Container, ContainerContent, ContainerPage, CustomLogo } from './styles'

import { AsideLogin } from 'redesign/components/organisms/AsideLogin'

interface TemplateContainerProps {
    children: ReactNode
    renderTemplateLogoNav?: boolean
}

export const TemplateABTest = ({ children, renderTemplateLogoNav = true }: TemplateContainerProps) => {
    const { currentLaboratory, currentLaboratoryStorage } = useCurrentLaboratory()
    const laboratory = currentLaboratory ? currentLaboratory : currentLaboratoryStorage

    return (
        <SnackbarProvider>
            <Container>
                <ContainerContent bgColor={laboratory?.titleBgColor}>
                    <ContainerPage>
                        {renderTemplateLogoNav && <CustomLogo alt={laboratory?.name} src={laboratory?.image} />}
                        {children}
                    </ContainerPage>
                </ContainerContent>

                <AsideLogin bgColor={laboratory?.titleBgColor} brandName={laboratory?.name} />

                <ThemeProvider theme={navTheme}>
                    <CustomSnackbar />
                </ThemeProvider>
            </Container>
        </SnackbarProvider>
    )
}
